<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/vue3';

    export default {
        components: {
            Link,
        },
        props: ['href', 'active'],

        computed: {
            classes() {
                return this.active
                    ? 'inline-flex items-center px-1 pt-1 border-b-2 border-golden-100 text-sm font-medium leading-5 text-rent-risk-blue-400 focus:outline-none focus:border-golden-100 transition '
                    : 'inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium leading-5 text-rent-risk-blue-400 hover:text-gray-300 hover:border-golden-100 focus:outline-none focus:text-white focus:border-golden-100 transition '
            }
        }
    }
</script>
